export const AGE_CONFIRMATION_STORAGE_KEY = 'chimolly-art-draft-cigar-age-confirmation-v1';
const CONFIRMED_VALUE = 'self-declared-21-plus:v1';

export function createAgeConfirmationSession({ getStorage = () => globalThis.window?.sessionStorage } = {}) {
  let confirmed;
  return {
    isConfirmed() {
      if (confirmed === undefined) {
        confirmed = false;
        try { confirmed = getStorage()?.getItem(AGE_CONFIRMATION_STORAGE_KEY) === CONFIRMED_VALUE; } catch {}
      }
      return confirmed;
    },
    confirm() {
      confirmed = true;
      try { getStorage()?.setItem(AGE_CONFIRMATION_STORAGE_KEY, CONFIRMED_VALUE); } catch {}
      return confirmed;
    },
    clear() {
      confirmed = false;
      try { getStorage()?.removeItem(AGE_CONFIRMATION_STORAGE_KEY); } catch {}
      return confirmed;
    }
  };
}

export function mountAgeEntry(root, session = createAgeConfirmationSession()) {
  const gate = root.querySelector('[data-age-gate]');
  const destination = root.querySelector('[data-age-destination]');
  const template = root.querySelector('[data-age-content]');
  const button = root.querySelector('[data-age-confirm]');
  if (!gate || !destination || !template || !button) return () => {};
  const win = root.ownerDocument.defaultView;
  let frame = 0;
  const render = focus => {
    const confirmed = session.isConfirmed();
    gate.hidden = confirmed;
    destination.replaceChildren(...(confirmed ? [template.content.cloneNode(true)] : []));
    destination.hidden = !confirmed;
    root.dataset.ageConfirmed = String(confirmed);
    if (!focus) return;
    win.cancelAnimationFrame(frame);
    frame = win.requestAnimationFrame(() => {
      const heading = root.querySelector(confirmed ? '[data-age-draft-heading]' : '[data-age-heading]');
      heading?.focus({ preventScroll: true });
      win.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    });
  };
  const click = event => {
    if (event.target.closest('[data-age-confirm]')) { session.confirm(); render(true); }
    if (event.target.closest('[data-age-reset]')) { session.clear(); render(true); }
  };
  button.disabled = false;
  root.addEventListener('click', click);
  render(true);
  return () => {
    win.cancelAnimationFrame(frame);
    root.removeEventListener('click', click);
    button.disabled = true;
    gate.hidden = false;
    destination.hidden = true;
    destination.replaceChildren();
    delete root.dataset.ageConfirmed;
  };
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const entries = new Map();
  const find = scope => [
    ...(scope.matches?.('[data-art-cigars]') ? [scope] : []),
    ...scope.querySelectorAll('[data-art-cigars]')
  ];
  const mount = scope => find(scope).forEach(root => {
    entries.get(root)?.();
    entries.set(root, mountAgeEntry(root));
  });
  const unmount = scope => find(scope).forEach(root => {
    entries.get(root)?.();
    entries.delete(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  window.addEventListener('pagehide', () => unmount(document));
  window.addEventListener('pageshow', event => { if (event.persisted) mount(document); });
}
